import { Entidad } from "../../../../data/Entidad";
import { IAsignacionInfoDescuento, ICargoRepeticion } from "../AlumnosCargosDescuentos";

import CTipoValor = Entidad.CFinanzaCargoTipoValor;

export function _GetTotalSaldoByCargoRep(cargoRep: ICargoRepeticion, localCalculate = false): number {
    const cargoInicial = cargoRep.ParentAsignacion.Valor;
    let saldo = cargoInicial;

    if (localCalculate) {
        cargoRep.Descuentos
            .forEach((desc) => {
                const descuentoMonto = _GetValorDescuentoRelativo(desc, cargoRep.Descuentos, cargoInicial);
                saldo -= descuentoMonto;
            });
    }
    else {
        saldo -= cargoRep.TotalDescuento;
    }

    return saldo;
}

export function _GetValorDescuentoRelativo(descuento: IAsignacionInfoDescuento, allDescuentos: IAsignacionInfoDescuento[], valorCargo: number): number {
    let valorDescuento = 0;

    for (let desc of allDescuentos) {
        if (desc.TipoValor == CTipoValor.Porcentaje) {
            valorDescuento = ((desc.Valor / 100) * valorCargo);
        } else {
            valorDescuento = desc.Valor;
        }

        if (desc.ID == descuento.ID) {
            break;
        }

        valorCargo -= valorDescuento;
    }

    return valorDescuento;
}